<div class="d-flex flex-column h-100 shadow-sm">
  <div class="d-grid calendar-week__grid--column bg-white">
    <!--Spacer-->
    <div></div>

    <!--Weekdays-->
    <div class="d-grid w-100 border-top border-start border-end rounded-top" style="grid-template-columns: repeat(7, 1fr); grid-column: 2/-1">
      <ng-container *ngFor="let weekday of dates">
        <div class="d-flex calendar-week__header align-items-center flex-column w-100">
          <span class="fs-5">{{ weekday.getDate() }}</span>
          <span class="text-black-50">{{ weekday | employeeDate: 'EEEE' | async }}</span>
        </div>
      </ng-container>
    </div>

    <div class="d-grid position-relative w-100 border-start border-end" style="grid-template-columns: repeat(7, 1fr); grid-column: 2/-1">
      <ng-container *ngFor="let event of dayEvents">
        <div class="d-flex justify-content-center calendar-week__event m-1 p-1 z-1" [ngStyle]="{ 'grid-column': event.startDate.getDay() + ' / ' + (event.endDate.getDay() + 1) }">{{ event.label }}</div>
      </ng-container>
      <div class="d-grid position-absolute w-100 h-100 z-0" style="grid-template-columns: repeat(7, 1fr)">
        <ng-container *ngFor="let weekday of dates">
          <div class="d-flex calendar-week__header border-top align-items-center flex-column w-100 h-100"></div>
        </ng-container>
      </div>
    </div>
  </div>
  <!--Content-->
  <div #scrollContainer class="border calendar-week__container rounded-bottom overflow-auto flex-grow-1">
    <div class="d-grid calendar-week__grid w-100">
      <!--Hours-->
      <div class="d-grid border-end calendar-week__hours" style="grid-template-rows: subgrid; grid-row: 1/-1; top: 0">
        <ng-container *ngFor="let hour of [].constructor(24); let i = index">
          <span>{{ i }}</span>
        </ng-container>
      </div>

      <!--Weekday-->
      <ng-container *ngFor="let weekday of dates">
        <div class="d-grid position-relative calendar-week__weekday">
          <!--Events-->
          <div class="calendar-week__events">
            <!--FOR every day in the week-->
            <ng-container *ngFor="let weekDayEvent of eventIndex?.at(weekday.getDay())">
              <!-- prettier-ignore -->
              <div
                class="w-100 p-1 overflow-hidden user-select-none"
                [ngStyle]="{ 
                  'grid-row': weekDayEvent.gridColumnStart + ' / ' + weekDayEvent.gridColumnEnd,
                  'grid-column': weekDayEvent.gridRowStart + ' / span ' + weekDayEvent.gridRowSpan 
                }"
                (click)="eventClick.emit({ date: weekday, event: $event, context: weekDayEvent.event, calendar: this })">
                  <!--The event itself.-->
                  <ng-container [ngTemplateOutlet]="dayTemplate ?? eventTmpl" [ngTemplateOutletContext]="{ calendarEvent: weekDayEvent.event, date: weekday, default: eventTmpl }"></ng-container>
                </div>
            </ng-container>
          </div>

          <div #ticker *ngIf="DateUtil.sameDay(weekday, today)" class="d-flex align-items-center position-absolute w-100">
            <i class="fas fa-circle progreso-primary position-relative" style="width: 0%; left: -0.5rem"></i>
            <hr class="progreso-primary w-100 m-0 p-0" style="opacity: 1" />
          </div>

          <ng-container *ngFor="let hour of [].constructor(24); let i = index">
            <!-- prettier-ignore -->
            <div 
              [class.cal--weekend]="(weekday.getDay() == 6 || weekday.getDay() == 0) && !settings?.disableWeekendsGrey"
              [class.cal--in-the-past]="weekday.getTime() < yesterday.getTime() && !settings?.disablePastDaysGrey"
              [class.cal--out-of-office]="(i < 9 || i >= 17 || i == 12) && !settings?.disableWeekendsGrey"
              
              class="d-flex flex-column w-100 h-100">
              <!--First 30 min-->
              <div 
                #weekDayItem
                (mousedown)="mouseDownEvent($event)"
                (mouseup)="mouseUpEvent($event)"
                
                [class.cal--selectable]="!settings?.disableDaySelect"

                class="calendar-week__hour-top h-100 w-100">
              </div>
              <!--Last 30 min-->
              <div
                #weekDayItem
                (mousedown)="mouseDownEvent($event)"
                (mouseup)="mouseUpEvent($event)"

                [class.cal--selectable]="!settings?.disableDaySelect"

                class="calendar-week__hour-bottom h-100 w-100">
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #eventTmpl let-calendarEvent="calendarEvent" let-date="date" let-customTextTmpl="customTextTmpl">
  <div [class.calendar-week__event--clickable]="!settings?.disableEventHover" class="calendar-week__event h-100 w-100 shadow">
    <ng-template [ngTemplateOutlet]="customTextTmpl ?? textTmpl" [ngTemplateOutletContext]="{ calendarEvent: calendarEvent, date: date }"></ng-template>
  </div>
</ng-template>

<ng-template #textTmpl let-calendarEvent="calendarEvent" let-date="date">
  <div class="calendar-week__event-content w-100 p-2" [title]="calendarEvent.label + '&#013;' + (calendarEvent.startDate | date: 'HH:mm') + ' - ' + (calendarEvent.endDate | date: 'HH:mm')">
    <span class="calendar-week__event-title text-truncate">{{ calendarEvent.label }}</span>
    <div class="d-flex justify-content-end align-items-center">
      <i *ngIf="calendarEvent?.faIcon" class="fas fa-fw me-1" [ngClass]="'fa-' + calendarEvent?.faIcon"></i>
    </div>
    <span>{{ calendarEvent.startDate | date: 'HH:mm' }} - {{ calendarEvent.endDate | date: 'HH:mm' }}</span>
  </div>
</ng-template>
